<div class="table-responsive gung-responsive">
  <table class="table table-borderless table-striped table-hover">
    <thead>
      <tr>
        <th scope="col" translate>ORDER_ID</th>
        <th scope="col" translate>ORDER_STATUS</th>
        @if(isSales){
          <th scope="col" translate>CUSTOMER</th>
        }
        <th scope="col" translate>ORDER_DATE</th>
        <th scope="col" translate>ESTIMATED_DELIVERY_DATE</th>
        <th scope="col" translate>TOTAL</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let order of data"
        (click)="goToDetail(order)"
        class="selectableRow"
      >
        <td [attr.data-label]="'ORDER_ID' | translate">{{ order.id }}</td>
        <td [attr.data-label]="'ORDER_STATUS' | translate" translate>{{order.extra.gme.status | translate}}</td>
        @if(isSales){
          <td [attr.data-label]="'CUSTOMER' | translate">
            {{order.extra.gme.customerId + ' - ' + order.extra.gme.customerName}}
          </td>
        }
        <td [attr.data-label]="'ORDER_DATE' | translate">
          {{order.extra.gme.orderDate | date: dateUtilService.dateFormat}}
        </td>
        <td [attr.data-label]="'ESTIMATED_DELIVERY_DATE' | translate">
          <span *ngIf="order?.extra?.gme?.deliveryDate">
            {{ order.extra.gme?.deliveryDate | date: dateUtilService.dateFormat }}
          </span>
        </td>
        <td [attr.data-label]="'TOTAL' | translate">
          <lib-price
            [price]="order.extra.gme.totalNetPrice || 0"
            [currency]="order.extra.gme.currencyCode"
            class="form-control-plaintext p-0"
          ></lib-price>
        </td>
        <td>
          @if (order?.extra.gme?.shipmentLinks?.length > 0) {
            @for (trackingLinkKey of order.extra.gme.shipmentLinks; track trackingLinkKey) {
              @if (!!trackingLinkKey.shipmentUrl) {
                <a (click)="$event.stopPropagation();" [href]="ensureHttp(trackingLinkKey.shipmentUrl)" target="_blank" class="icon-link ml-2">
                  <i class="far fa-truck" [ngbTooltip]="trackingLinkKey.shipmentId"></i>
                </a>
              }
            }
          }
          <a href="{{ baseUrl + 'download/order-pdf/' + order.id }}" download="{{ order.id + '.pdf' }}" (click)="$event.stopPropagation()" class="ml-2">
            <i class="far fa-file-pdf"></i>
          </a>
        </td>
      </tr>
    </tbody>
  </table>
</div>
